// core/i18n/i18n.ts
import { fallbackMessages } from './fallback-translations';

export type TranslateFunction = (key: string, params?: Record<string, any>) => string;

let translator: TranslateFunction | null = null;

export function setTranslator(fn: TranslateFunction) {
  translator = fn;
}

function interpolate(str: string, params: Record<string, any> = {}) {
  // eslint-disable-next-line require-unicode-regexp
  return str.replace(/{(?<temp1>[^}]+)}/g, (_, key) => params[key] ?? `{${key}}`);
}

export function t(key: string, params?: Record<string, any>): string {
  if (translator) {
    return translator(key, params);
  }

  const fallback = fallbackMessages[key];
  if (fallback) {
    return interpolate(fallback, params);
  }

  if (process.env.NODE_ENV !== 'production') {
    console.warn(`[core] Missing translation key: "${key}"`);
  }

  return key;
}
